// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cnt-area[data-v-fef1f074]{margin-top:40px}.list-table[data-v-fef1f074]{border:1px solid #ebeef5}.question[data-v-fef1f074]{margin-top:20px}.popover-slider-bar .form-button[data-v-fef1f074]{padding-left:40%}.ellips2[data-v-fef1f074]{display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;overflow:hidden;max-height:45px}", ""]);
// Exports
module.exports = exports;
